import { createMuiTheme } from '@material-ui/core/styles';

const palette = {
  type: 'dark',
  primary: { main: '#009e9e' },
  secondary: { main: '#d36200' }
};
const themeName = 'Dove Gray';
export default createMuiTheme({ palette, themeName });
